import { MissionToLecStaff } from '../../lib/types/models/mission-to-lec-staff/mission-to-lec-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedLecStaffs(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missions.getAffectedLecStaffs.url, { id }))
    .get<MissionToLecStaff[]>()
}
